<div class="status-messages">
	@for (message of notificationService.statusMessages; track message) {
		<div (click)="removeMessage(message)" animate.enter="fade-in" animate.leave="fade-out">
			@if (message.icon) { <icon small [type]="message.icon" /> }
			{{ message.languageVariable | translate }}
			{{ message.text }}
		</div>
	}
	@if (connectionState != 'connected') {
		<div (click)="pushService.startConnection()" animate.enter="fade-in" animate.leave="fade-out">
			<icon small type="signal-slash" class="connection-state" [ngClass]="connectionState" />
			{{ ('status.connection.' + connectionState) | translate }}
		</div>
	}
</div>
